import { includes } from 'ramda';

import { setValue } from '@gef-ui/form-core/stream/transfer/control';

import { processes } from '../contactReleasing/constants';
import { CAMPAIGN_MANAGEMENT_SIDEBAR_FORM_NAME, FIELDS } from './form';

export const resetOtherSidebarFields =
	(process) =>
	async (dispatch, getState, { sendControlNext }) => {
		if (includes(process, [processes.CONTACT_RELEASE, processes.MANUAL_ASSIGN])) {
			sendControlNext(
				CAMPAIGN_MANAGEMENT_SIDEBAR_FORM_NAME,
				setValue({ fieldName: FIELDS.printMode, value: null }),
			);
			sendControlNext(
				CAMPAIGN_MANAGEMENT_SIDEBAR_FORM_NAME,
				setValue({ fieldName: FIELDS.automaticAssign, value: null }),
			);
		}
		if (process === processes.PRINT_MODE) {
			sendControlNext(
				CAMPAIGN_MANAGEMENT_SIDEBAR_FORM_NAME,
				setValue({ fieldName: FIELDS.automaticAssign, value: null }),
			);
		}
		if (process === processes.AUTOMATIC_ASSIGN) {
			sendControlNext(
				CAMPAIGN_MANAGEMENT_SIDEBAR_FORM_NAME,
				setValue({ fieldName: FIELDS.printMode, value: null }),
			);
		}
	};
